Alpine.magic('requestPhotos', (_, {evaluate, Alpine}) =>{
    return () => {
        fetch('/request-photos', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
            },
            body: JSON.stringify({
                main_event_id: Alpine.store('cart').mainEvent.id
            })
        })
        .then((response) => response.json())
        .then((data) => {
            if(data.no_has_products){
                return evaluate('$store.customerImages.myAlbum($dispatch, true, {tab: 0})')
            }

            if(data.has_prepaid){
                return evaluate("$store.customerImages.goToCheckoutWizard(Alpine.store('cart').mainEvent.id)")
            }

            evaluate("$store.customerImages.goToProducts(Alpine.store('cart').mainEvent.id)")
        })
        .catch(() => {
            window.$wireui.notify({
                title: 'Request Photos Failed.',
                description: 'Something went wrong, please try again!',
                icon: 'warning'
            });
        });
    }
});
